import { render } from "./LogViewer.vue?vue&type=template&id=bb060d6c&scoped=true"
import script from "./LogViewer.vue?vue&type=script&lang=js"
export * from "./LogViewer.vue?vue&type=script&lang=js"

import "./LogViewer.vue?vue&type=style&index=0&id=bb060d6c&scoped=true&lang=scss"

import exportComponent from "/tmp/b7562a83-daa0-4796-bff7-c3f4922e39c8/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb060d6c"]])

export default __exports__